<div class="text-center text-secondary py-5" *ngIf="loading">Loading email…</div>
<div class="empty py-5" *ngIf="!loading && !messages.length">
  <i class="ti ti-mail-off empty-icon" aria-hidden="true"></i>
  <p class="empty-title">{{ emptyTitle }}</p>
  <p class="empty-subtitle">{{ emptyDescription }}</p>
  <button type="button" class="btn btn-primary" (click)="composeRequested.emit()">New email</button>
</div>
<div class="email-message-list" *ngIf="!loading && messages.length">
  <button type="button" class="card email-message text-start w-100" *ngFor="let message of messages" (click)="messageSelected.emit(message)">
    <div class="card-body">
      <div class="d-flex justify-content-between gap-3">
        <strong class="text-truncate">{{ message.subject || '(No subject)' }}</strong>
        <time class="small text-secondary text-nowrap">{{ message.received_at | localDateTime }}</time>
      </div>
      <div class="small text-secondary mt-1 text-truncate">{{ message.from.name || message.from.address }} → {{ message.to[0]?.name || message.to[0]?.address || 'me' }}</div>
      <p class="mb-0 mt-2 text-secondary text-truncate">{{ message.preview || message.text_body }}</p>
      <span class="badge bg-secondary-lt mt-2" *ngIf="message.attachments.length">
        <i class="ti ti-paperclip" aria-hidden="true"></i> {{ message.attachments.length }} attachment{{ message.attachments.length === 1 ? '' : 's' }}
      </span>
    </div>
  </button>
</div>
